import React from 'react';
import { motion } from 'framer-motion';
import { Construction, X } from 'lucide-react';
import Button from './ui/Button';

interface DisabledFeatureDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const DisabledFeatureDialog: React.FC<DisabledFeatureDialogProps> = ({
  isOpen,
  onClose
}) => {
  if (!isOpen) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-50 bg-background/80 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={onClose}
    >
      <motion.div
        initial={{ scale: 0.95 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0.95 }}
        onClick={(e) => e.stopPropagation()}
        className="relative bg-card border rounded-lg shadow-lg max-w-md w-full p-6"
      >
        <Button
          variant="ghost"
          size="sm"
          className="absolute right-4 top-4"
          onClick={onClose}
        >
          <X className="w-4 h-4" />
        </Button>

        <div className="flex items-center gap-4 mb-6">
          <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
            <Construction className="w-6 h-6 text-primary" />
          </div>
          <div>
            <h3 className="text-lg font-semibold">Feature in Development</h3>
            <p className="text-sm text-muted-foreground">
              This feature is currently being developed and will be available soon!
            </p>
          </div>
        </div>

        <Button onClick={onClose} className="w-full">
          Got it
        </Button>
      </motion.div>
    </motion.div>
  );
};

export default DisabledFeatureDialog;